import styles from './spinner.module.css'

// simple loading spinner component
export const LoadingSpinner = ({ size, color }) => {
	return (
		<div
			className={styles.spinner}
			style={{
				width: size,
				height: size,
				borderTopColor: color,
			}}
		></div>
	)
}

export const PageLoadingSpinner = ({ size = 60, color = 'var(--brand)' }) => {
	return (
		<div className={styles.pageOverlay}>
			<div className={styles.spinnerContainer}>
				<LoadingSpinner size={size} color={color} />
			</div>
		</div>
	)
}